"use client";

import { tutorialStore } from "@/shared/stores/TutorialStore";
import { useTranslation } from "@cronika/locales";
import { observer } from "mobx-react-lite";
import { FC, useEffect } from "react";

export const ReplayTutorialButton: FC = observer(() => {
  const { t } = useTranslation("trading");

  useEffect(() => {
    void tutorialStore.load();
  }, []);

  if (!tutorialStore.loaded || !tutorialStore.enabled) return null;

  const handleDismiss = () => {
    tutorialStore.setEnabled(false);
  };

  return (
    <div className="mt-2 flex shrink-0 items-center justify-center gap-3 rounded-xl border border-default-500/40 bg-default-500/15 py-2.5 pl-4 pr-2.5">
      <button
        type="button"
        onClick={() => window.dispatchEvent(new CustomEvent("cronika:onboarding-replay-requested"))}
        className="flex items-center gap-1 text-[13px] font-semibold text-white transition-colors hover:text-default-300"
      >
        {t("onboarding-replay.cta")}
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <g clip-path="url(#clip0_7998_37735)">
            <path
              d="M10.125 0.75H1.875C1.25475 0.75 0.75 1.25475 0.75 1.875V7.125C0.75 7.74525 1.25475 8.25 1.875 8.25H10.125C10.7452 8.25 11.25 7.74525 11.25 7.125V1.875C11.25 1.25475 10.7452 0.75 10.125 0.75ZM10.5 7.125C10.5 7.332 10.3316 7.5 10.125 7.5H1.875C1.66838 7.5 1.5 7.332 1.5 7.125V1.875C1.5 1.66838 1.66838 1.5 1.875 1.5H10.125C10.3316 1.5 10.5 1.66838 10.5 1.875V7.125ZM10.875 9.75H3.681C3.52575 9.31462 3.11325 9 2.625 9C2.13675 9 1.72425 9.31462 1.569 9.75H1.125C0.918 9.75 0.75 9.91763 0.75 10.125C0.75 10.3324 0.918 10.5 1.125 10.5H1.569C1.72425 10.9354 2.13675 11.25 2.625 11.25C3.11325 11.25 3.52575 10.9354 3.681 10.5H10.875C11.082 10.5 11.25 10.3324 11.25 10.125C11.25 9.91763 11.082 9.75 10.875 9.75ZM2.625 10.5C2.41838 10.5 2.25 10.332 2.25 10.125C2.25 9.918 2.41838 9.75 2.625 9.75C2.83162 9.75 3 9.918 3 10.125C3 10.332 2.83162 10.5 2.625 10.5ZM5.25 6.39563C5.12437 6.39563 4.99875 6.3645 4.88513 6.30112C4.64775 6.16875 4.50038 5.91787 4.50038 5.646V3.35475C4.50038 3.08288 4.64813 2.83162 4.88513 2.69963C5.1225 2.56725 5.41388 2.574 5.6445 2.71687L7.49662 3.8625C7.71937 4.0005 7.85212 4.23863 7.85212 4.50038C7.85212 4.76213 7.71938 5.00025 7.497 5.13825L5.64488 6.28425C5.5245 6.35887 5.38725 6.396 5.25038 6.396L5.25 6.39563ZM5.24813 3.35325L5.25 5.64563L7.10212 4.5L5.24813 3.35325Z"
              fill="#FBFBFB"
            />
          </g>
          <defs>
            <clipPath id="clip0_7998_37735">
              <rect width="12" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </button>
      <button
        type="button"
        onClick={handleDismiss}
        aria-label={t("onboarding-replay.dismiss")}
        className="flex h-6 w-6 shrink-0 items-center justify-center text-default-500 transition-colors hover:text-white"
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1l10 10M11 1 1 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </button>
    </div>
  );
});
